import React from 'react'
import { AppImg } from '@web/walter-ui-kit'
import { Link } from 'react-router-dom'

import styles from './style.module.css'
import { Routes } from '~constants/routes'
import { images } from '~constants/images'

interface Props {
    isAuthPage?: boolean
}

function Logo({ isAuthPage }: Props) {
    return (
        <Link
            to={isAuthPage ? `/${Routes.signIn}` : `/${Routes.wallet}`}
            data-pointer="home_link"
            className={styles.wrap}
        >
            <AppImg imgName={images.logoNew} />
        </Link>
    )
}

export default Logo
